import { render, staticRenderFns } from "./ParticipantPage.vue?vue&type=template&id=dc46bf52&class=study-participant-page&"
import script from "./ParticipantPage.vue?vue&type=script&lang=ts&"
export * from "./ParticipantPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VScrollXTransition})
